export const experience = {
  en: {
    title: 'Experience',
    positions: {
      ai_intern: {
        title: 'AI Intern – Chip & Cia',
        date: 'June 2024 – March 2025',
        description: 'Co-author of <a href=\'https://revistas.inpi.gov.br/pdf/Programa_de_computador2827.pdf\'>AssessorAI</a>, an INPI-registered system that automates legal opinions using LLMs and RAG pipeline with LangChain. Integration via OpenAI/Ollama, with custom chains.'
      },
      campus_mobile: {
        title: 'Participant – Campus Mobile',
        date: 'January 2025 – February 2025',
        description: 'Participant in the Health category of the 13th Edition of the Campus Mobile Program, with the <a href=\'https://www.institutoclaro.org.br/nossas-novidades/conheca-os-projetos-selecionados-para-a-13a-edicao-do-campus-mobile/\'>HelpU</a> Project, an app for dentists that performs radiographic reports through CNNs, with prototype developed in FlutterFlow and Python.'
      },
      frontend_dev: {
        title: 'Frontend Developer – Softeam',
        date: 'April 2019 – September 2020',
        description: 'Development of web applications using ReactJS, working on building a system to manage tax, social security, and labor expenses with domestic employees.'
      },
      lawyer: {
        title: 'Independent Lawyer – Charlie Fonseca | Law & Consulting',
        date: 'February 2015 – Present',
        description: 'Specialized practice in Real Estate and Civil Law, strengthening the integration between technological solutions and automation of legal processes.'
      }
    }
  },
  pt: {
    title: 'Experiência',
    positions: {
      ai_intern: {
        title: 'Estagiário em Inteligência Artificial – Chip & Cia',
        date: 'Junho 2024 – Março 2025',
        description: 'Coautor do <a href=\'https://revistas.inpi.gov.br/pdf/Programa_de_computador2827.pdf\'>AssessorAI</a>, sistema registrado no INPI que automatiza a geração de pareceres jurídicos utilizando LLMs e pipeline RAG com LangChain. Integração via OpenAI/Ollama, com chains customizadas.'
      },
      campus_mobile: {
        title: 'Participante – Campus Mobile',
        date: 'Janeiro 2025 – Fevereiro 2025',
        description: 'Participante na categoria Saúde da 13ª Edição do Programa Campus Mobile, com o Projeto <a href=\'https://www.institutoclaro.org.br/nossas-novidades/conheca-os-projetos-selecionados-para-a-13a-edicao-do-campus-mobile/\'>HelpU</a>, um aplicativo para cirurgiões-dentista que faz laudos radiográficos através de CNNs, com protótipo desenvolvido em FlutterFlow e Python.'
      },
      frontend_dev: {
        title: 'Desenvolvedor Front-end – Softeam',
        date: 'Abril 2019 – Setembro 2020',
        description: 'Desenvolvimento de aplicações web utilizando ReactJS, atuando na construção de um sistema para gerir as despesas fiscais, previdenciárias e trabalhistas com empregados domésticos.'
      },
      lawyer: {
        title: 'Advogado Autônomo – Charlie Fonseca | Advocacia e Consultoria',
        date: 'Fevereiro 2015 – Presente',
        description: 'Atuação especializada em Direito Imobiliário e Cível, fortalecendo a integração entre soluções tecnológicas e automação de processos legais.'
      }
    }
  }
};